import styled from 'styled-components';

const clsPrefix = 'list-item-title-desc-icon';

export const cssClasses = {
  wrapper: clsPrefix,
  title: `${clsPrefix}-title`,
  icon: `${clsPrefix}-icon`,
  description: `${clsPrefix}-description`,
  descriptionWrapper: `${clsPrefix}-description-rapper`,
} as const;

export const ListItemTitleDescIconSC = styled.div`
  .${cssClasses.title} {
    margin-bottom: 4px;
    color: ${({ theme }) => theme.color.tint.action};
    ${({ theme }) => theme.mappedTypography.overline.default};
  }

  .${cssClasses.descriptionWrapper} {
    display: flex;
    align-items: center;

    .${cssClasses.description} {
      color: ${({ theme }) => theme.color.tint.tertiary};
      ${({ theme }) => theme.mappedTypography.captionLarge.default};
    }
  }
`;
